import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist();
export const newOperationIdState = atom<string>({
  key: 'newOperationIdState',
  default: '',
  effects_UNSTABLE: [persistAtom],
});
